module.exports = __webpack_public_path__ + "img/licoin.7070e9e8.svg";